<template>
  <div class="row">
    <div class="col-6">
      <label class="filter-label"> {{ label_parent }}: </label>      
      <select
        class="form-control"
        v-model="parent_id"
        @change="passEventToGetChild($event)"
        :name="this.name_parent"
        :required="must_required == true ? true : false"
        :disabled=is_archived
      >
        <option value="null">---</option>
        <option v-for="row in parent_list" :value="row.id" v-bind:key="row.id">
          {{ row.name }}
        </option>
      </select>
    </div>
    <div class="col-6">
      &nbsp;<label class="filter-label"> {{ label_children }}: </label>
      <select
        class="form-control"
        v-model="child_id"
        :name="name_children"
        :required="must_required == true ? true : false"
        :disabled=is_archived
      >
        <option v-for="row in children_list" :value="row.id" v-bind:key="row.id">
          {{ row.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    //setup parent_list and default values
    this.parent_id = this.parent_id_default; 

    if (this.child_id_default !== "0") {
      //case edit, populate the child_list and set default child
      this.child_id = this.child_id_default;
      this.getChild(this.child_id);
    }
  },
  props: {
    parent_list: {
      type: Array,
      required: true,
    },
    parent_id_default: {
      type: [String, Number],
      required: false,
      default: null,
    },
    child_id_default: {
      type: Number,
      required: false,
      default: null,
    },
    label_children: {
      type: String,
      required: true,
    },
    label_parent: {
      type: String,
      required: true,
    },
    name_children: {
      type: String,
      required: true,
    },
    name_parent: {
      type: String,
      required: false,
      default: "",
    },
    parent_key: {
      type: String,
      required: true,
    },
    model: {
      type: String,
      required: true,
    },
    end_point: {
      type: String,
      required: false,
      default: "default",
    },
    must_required: {
      type: Boolean,
      required: false,
      default: true,
    },
    is_archived: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      parent_id: null,
      child_id: null,
      children_list: [],
    };
  },
  methods: {
    passEventToGetChild(event) {
      this.getChild(event.target.value);
    },

    getChild(id) {
      let url =
        "/get-children-of-parent/" +
        this.parent_id +
        "/parent_id/" +
        this.parent_key +
        "/parent_key/" +
        escape(this.model) +
        "/model";
      let params = {};
      if (this.end_point !== "default") {
        url = this.end_point;
        params["parent_id"] = this.parent_id;
      }

      axios.get(url, { params: params }).then((response) => {
        this.children_list = response.data;
      });
    },
  },
};
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
.compensation-filter {
  width: 160px;
  font-size: 14px;
}
.filter-label {
  color: #1767a2;
  font-size: 14px;
}
</style>
